import { registerEntries } from 'actions/index';

import {
  route as homeRoute,
  item as homeItem,
  itemFront,
  routeFront,
  routeFrontEdit,
  routeFrontSingle,
  previewItem,
  previewRoute,
  itemFrontEdit,
  routeFrontCreate,
  itemFrontCreate,
  transactionItem,
  itemFrontSingle,
  routeFrontUuid,
  routeFrontInvoice,
} from './home/route';
import { route as loginRoute } from './login/route';
import { routes as articlesRoutes, submenu as articlesSubmenu } from './obituaries/routes';
import { routes as reportsRoutes, submenu as reportsSubmenu } from './reports/routes';
import { routes as forgotPasswordRoutes } from './resetPassword/routes';
import { routes as transactionRoutes, submenu as transactionSubmenu } from './transactions/routes';
import { routes as usersRoutes, submenu as usersSubmenu } from './users/routes';

export const routes = [
  homeRoute,
  loginRoute,
  previewRoute,
  routeFront,
  routeFrontInvoice,
  routeFrontEdit,
  routeFrontSingle,
  routeFrontCreate,
  routeFrontUuid,
  ...usersRoutes,
  ...forgotPasswordRoutes,
  ...articlesRoutes,
  ...reportsRoutes,
  ...transactionRoutes,
];

// REGISTER ROUTES IN SIDEBAR
setTimeout(() => {
  window.store.dispatch(
    registerEntries([
      homeItem,
      usersSubmenu,
      articlesSubmenu,
      reportsSubmenu,
      itemFront,
      itemFrontEdit,
      itemFrontSingle,
      previewItem,
      itemFrontCreate,
      transactionSubmenu,
      transactionItem,
    ]),
  );
});
